import api from './api'

/**
 * PDF of the customer's own order (customer JWT). Same format as the admin viewer.
 */
export async function getMyOrderPdfBlob(orderId, locale = 'fr') {
  const loc = String(locale || '').toLowerCase() === 'en' ? 'en' : 'fr'
  const response = await api.get(`/orders/${orderId}/pdf`, {
    responseType: 'blob',
    params: { locale: loc },
  })
  return response.data
}
